<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Agendamentos</h2>
                    </div>
                </div>
                <div class="panel-body" (window:resize)="onResize($event)">
                    <table mat-table [dataSource]="dataSource" matSort class="table table-striped">
                        <ng-container matColumnDef="dataMarcacao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 70px;"> Data </th>
                            <td mat-cell *matCellDef="let marcacaoDTO"> {{marcacaoDTO.dataMarcacao |
                                date:"dd/MM/yyyy"}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="horaAtendimento">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 55px;"> Hora </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" >
                                {{marcacaoDTO.horaAtendimento |
                                horaFormatadaPipe}} </td>
                        </ng-container>

                        <ng-container matColumnDef="nomePaciente" >
                            <th mat-header-cell *matHeaderCellDef mat-sort-header > Paciente </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" > {{marcacaoDTO.nomePaciente}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="nomePacienteTitular" >
                            <th mat-header-cell *matHeaderCellDef mat-sort-header > Titular </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" >
                                {{marcacaoDTO.nomePacienteTitular}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="nomeFilial" >
                            <th mat-header-cell *matHeaderCellDef mat-sort-header > Filial </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" >
                                {{marcacaoDTO.nomeFilial}} </td>
                        </ng-container>

                        <ng-container matColumnDef="nomeProcedimento" >
                            <th mat-header-cell *matHeaderCellDef mat-sort-header > Exame </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" >
                                {{marcacaoDTO.nomeProcedimento}} </td>
                        </ng-container>
                        
                        <ng-container matColumnDef="nomeProcedimentoConsulta" >
                            <th mat-header-cell *matHeaderCellDef mat-sort-header > Consulta </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" >
                                {{marcacaoDTO.nomeProcedimentoConsulta}} </td>
                        </ng-container>

                        <ng-container matColumnDef="dilataPupila" >
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 60px;"> Dilata Pupila
                            </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" > {{marcacaoDTO.dilataPupila |
                                simNaoPipe}} </td>
                        </ng-container>

                        <ng-container matColumnDef="nomeMedico" >
                            <th mat-header-cell *matHeaderCellDef mat-sort-header > Médico </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" > {{marcacaoDTO.nomeMedico}}
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="voltarPaginaAnterior()"
                                matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>